import { Navigate } from 'react-router-dom'
import { Page } from '@/components/layout/Page'
import { FullPageSpinner } from '@/components/common/Spinner'
import { SignedOutCard } from '@/components/signedOut/SignedOutCard'
import { useSession } from '@/auth/useSession'

/**
 * Post-logout landing. Reached via Passport's `post_logout_redirect_uri`
 * or by bookmark / direct nav.
 *
 * Guard: if the user is already authenticated (e.g. they bookmarked this
 * URL while logged in, or hit "back" after signing in again), bounce them
 * to `/` so they don't see a stale "signed out" message. While the
 * userManager is still hydrating we show a spinner rather than flashing
 * the card, then decide.
 */
export function SignedOutPage() {
  const { isLoading, isAuthenticated } = useSession()

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <Page variant="center">
      {isLoading ? (
        <FullPageSpinner label="Loading your session" />
      ) : (
        <SignedOutCard />
      )}
    </Page>
  )
}
